import { SELECTED_ISSUE_PARAM } from '@atlassian/jira-business-constants/src/index.tsx';
import { useQueryParam } from '@atlassian/react-resource-router';

export const useIssueViewIsVisible = () => {
	const [selectedIssueKey] = useQueryParam(SELECTED_ISSUE_PARAM);

	return selectedIssueKey != null;
};
